module.exports = __webpack_public_path__ + "img/Mark_Kay_2017.fba51f13.png";